import axios from "axios";
import { create } from "zustand";
import productStore from "./productStore";
import Cookies from "js-cookie";

const cartStore = create((set) => ({
  cartProduct: null,
  noSignCartProduct: null,
  isLoading: true,

  subTotalAmount: 0,
  discountAmount: 0,
  beforeCouponAmount: 0,
  couponAmount: 0,
  totalAmount: 0,

  setIsLoading: ({ value }) => {
    set({ isLoading: value });
  },

  setCartProductNull: () => {
    set({ cartProduct: null });
  },

  setAmount: ({ name, value }) => {
    set({ [name]: value });
  },

  noSignInAdd: ({ productID, selectedColor, selectedSize }) => {
    const { cartProduct } = cartStore.getState();

    const data = cartProduct ? cartProduct : [];

    data.push({ productID, selectedColor, selectedSize, qty: 1 });

    set({ cartProduct: data, noSignCartProduct: data });
  },

  noSignInRemove: ({ productID }) => {
    const { cartProduct } = cartStore.getState();

    const data = cartProduct.filter((item) => {
      return item.productID !== productID;
    });

    if (data.length === 0) {
      set({ cartProduct: null, noSignCartProduct: null });
    } else {
      set({ cartProduct: data, noSignCartProduct: data });
    }
  },

  noSignUpdateSize: ({ productID, size }) => {
    const { cartProduct } = cartStore.getState();
    const newCateProduct = [...cartProduct];
    const indexCateProduct = cartProduct.findIndex((item) => {
      return item.productID === productID;
    });

    newCateProduct[indexCateProduct].selectedSize = size;

    set({ cartProduct: newCateProduct });
  },

  noSignUpdateColor: ({ productID, color }) => {
    const { cartProduct } = cartStore.getState();
    const newCateProduct = [...cartProduct];
    const indexCateProduct = cartProduct.findIndex((item) => {
      return item.productID === productID;
    });

    newCateProduct[indexCateProduct].selectedColor = color;

    set({ cartProduct: newCateProduct });
  },

  noSignUpdateQty: ({ productID, qty }) => {
    const { cartProduct } = cartStore.getState();
    const newCateProduct = [...cartProduct];
    const indexCateProduct = cartProduct.findIndex((item) => {
      return item.productID === productID;
    });

    newCateProduct[indexCateProduct].qty = qty;

    set({ cartProduct: newCateProduct });
  },

  whenSignInAdd: async () => {
    try {
      const { noSignCartProduct, fetchAllCartProduct, cartProduct } =
        cartStore.getState();
      await fetchAllCartProduct();

      if (noSignCartProduct && noSignCartProduct.length) {
        noSignCartProduct.map(async (item) => {
          if (cartProduct && cartProduct.length) {
            let flag = true;
            cartProduct.map(async (mItem) => {
              if (mItem.productID === item.productID) {
                flag = false;
              }
            });
            if (flag) {
              await axios.post(
                "/site/add-to-cart-product",
                {
                  productID: item.productID,
                  selectedSize: item.selectedSize,
                  selectedColor: item.selectedColor,
                  qty: item.qty,
                }
              );
            }
          }
        });
        await fetchAllCartProduct();
      }
    } catch (error) {
      console.log(error);
    }
  },

  signInAdd: async ({ productID, selectedColor, selectedSize, qty = 1 }) => {
    try {
      const res = await axios.post(
        "/site/add-to-cart-product",
        {
          productID,
          selectedSize,
          selectedColor,
          qty,
        }
      );

      const { cartProduct } = cartStore.getState();
      const data = cartProduct ? cartProduct : [];
      data.push(res.data.cartProduct);
      set({ cartProduct: data });
    } catch (error) {
      console.log(error);
    }
  },

  signInRemove: async ({ cartID }) => {
    try {
      const { cartProduct } = cartStore.getState();
      const data = cartProduct.filter((item) => {
        return item._id !== cartID;
      });

      if (data.length === 0) {
        set({ cartProduct: null });
      } else {
        set({ cartProduct: data });
      }

      await axios.delete(`/site/remove-to-cart-product/${cartID}`);
    } catch (error) {
      console.log(error);
    }
  },

  outOfStockProductRemoveCart: async () => {
    try {
      const { cartProduct, signInRemove } = cartStore.getState();
      const { mProduct } = productStore.getState();
      if (cartProduct) {
        cartProduct.map((cartItem) => {
          mProduct.map(async (productItem) => {
            if (
              productItem._id === cartItem.productID &&
              !productItem.publish
            ) {
              await signInRemove({ cartID: cartItem._id });
            }
          });
        });
      }
    } catch (error) {
      console.log(error);
    }
  },

  fetchAllCartProduct: async () => {
    try {
      const res = await axios.get("/site/fetch-all-cart-product");
      if (res.data.cartProduct.length) {
        set({ cartProduct: res.data.cartProduct });
      }
      set({ isLoading: false });
    } catch (error) {
      console.log(error);
    }
  },

  signInUpdateSize: async ({ _id, size }) => {
    try {
      await axios.put(
        `/site/update-product-size/${_id}`,
        {
          selectedSize: size,
        }
      );

      const { cartProduct } = cartStore.getState();
      const newCateProduct = [...cartProduct];
      const indexCateProduct = cartProduct.findIndex((item) => {
        return item._id === _id;
      });

      newCateProduct[indexCateProduct].selectedSize = size;

      set({ cartProduct: newCateProduct });
    } catch (error) {
      console.log(error);
    }
  },

  signInUpdateColor: async ({ _id, selectedColor }) => {
    try {
      await axios.put(
        `/site/update-product-color/${_id}`,
        {
          selectedColor,
        }
      );

      const { cartProduct } = cartStore.getState();
      const newCateProduct = [...cartProduct];
      const indexCateProduct = cartProduct.findIndex((item) => {
        return item._id === _id;
      });

      newCateProduct[indexCateProduct].selectedColor = selectedColor;

      set({ cartProduct: newCateProduct });
    } catch (error) {
      console.log(error);
    }
  },

  signInUpdateQty: async ({ _id, qty }) => {
    try {
      const { cartProduct } = cartStore.getState();
      const newCateProduct = [...cartProduct];
      const indexCateProduct = cartProduct.findIndex((item) => {
        return item._id === _id;
      });

      newCateProduct[indexCateProduct].qty = qty;

      set({ cartProduct: newCateProduct });

      await axios.put(
        `/site/update-product-qty/${_id}`,
        {
          qty,
        }
      );
    } catch (error) {
      console.log(error);
    }
  },

  whenOrderCartEmpty: async () => {
    try {
      await axios.delete("/site/empty-cart");
      set({ cartProduct: null });
    } catch (error) {
      console.log(error);
    }
  },
}));

export default cartStore;
